"use client";

import React from "react";
import styles from "./InsideTheLab.module.scss";

const InsideTheLab = () => {
	return (
		<section className={styles["inside-the-lab"]}>
			<h2 className={styles["inside-the-lab__title"]}>#insidethelab</h2>
			<div className={styles["inside-the-lab__content-wrapper"]}>
				<div className={styles["inside-the-lab__content"]}>
					<h3>The Forces That Propel Us Forward</h3>
					<div className={styles["inside-the-lab__content-p"]}>
						<p>The web fascinates us. Not just as a canvas, but as a catalyst—a medium capable of creating shared experiences at scale and sparking real change. Every project that crosses our desk is an invitation to ask better questions, challenge assumptions, and uncover solutions that didn't exist before we started.</p>
						<p>We're equal parts engineering and design studio, which means we obsess over both how things look and how they work. Elegance without efficiency is decoration. Efficiency without elegance is forgettable. We pursue both.</p>
					</div>
				</div>
				<img src="/images/round-stamp.svg" alt="" width={120} height={120} />
			</div>
		</section>
	);
};

export default InsideTheLab;
